/* eslint-disable import/prefer-default-export */
export function filterLockedSuppliers(apiMethod) {
  return (...props) =>
    apiMethod(...props).then(objects =>
      objects.filter(supplier => !supplier.name.includes('gesperrt')),
    );
}
